export default __webpack_public_path__ + "static/media/Neophyte's Tunic of Secret Doors.2958dd15.jpg";